// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"b3624399","850":"780c7125"}[chunkId] + ".chunk.js";
};